import { styled } from '@mui/material/styles';
import { ButtonGroup } from '@mui/material';

export const ScorecardToggleGroup = styled(ButtonGroup)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginLeft: theme.spacing(1),
  boxShadow: 'none',
  '@media print': {
    display: 'none',
  },
}));
